
import classnames from 'classnames'
import moment from 'moment'
import Avatar from "@components/avatar"

import {
  CardText,
  Badge,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap"

import {
  MoreVertical
} from 'react-feather'

import { fallbackImage_ } from '../../../../helpers/default_helper'

export const CardRoom = (props) => {

  return (
    <>
      <div className='col-1 p-0 d-flex justify-content-between col-12'>
        <li
          className={classnames("d-flex justify-content-between p-1 col-11 list-group-item border-0 text-decoration-none p-0 cursor-pointer", {
            active: props.item.id === props.selected ? true : false
          })}
          onClick={props.onSelectUser}
        >
          <Avatar onError={fallbackImage_} img={props.item.avatar} imgHeight='42' imgWidth='42' style={{ marginRight: 12 }} className="border border-white" />

          <div className='chat-info flex-grow-1'>
            <strong className='mb-0'>
              {props.item.name}
            </strong>
            <CardText className='text-muted'>
              {
                props.item.last_message.length > 20 ? props.item.last_message.substring(0, 20) + "..." : props.item.last_message
              }
            </CardText>
          </div>
          <div className='chat-meta text-nowrap text-right '>
            <small className='float-end mb-25 chat-time ms-25 d-block'>{moment(props.item.time).format('HH:mm')}</small>
            {
              props.item.un_read_message !== 0 ? (
                <Badge className='float-end' color='primary'>
                  {props.item.un_read_message}
                </Badge>
              ) : (
                props.item.is_un_read ? (
                  <Badge className='float-end' color='primary'>
                    0
                  </Badge>
                ) : null
              )
            }
          </div>
        </li>

        <div className='p-0 col-1 text-center'>
          <UncontrolledButtonDropdown className="d-lg-block d-none align-self-center">
            <DropdownToggle tag='span' className="align-self-center" >
              <div className='p-0 pt-1 pb-1 text-center'>
                <MoreVertical size={20} className='cursor-pointer m-0 m-auto' />
              </div>
            </DropdownToggle>
            <DropdownMenu direction='start'>
              <DropdownItem className='w-100' onClick={() => props.endConversation(props.item.id)}>
                <span className='align-middle'>Hapus Percakapan</span>
              </DropdownItem>
              {
                props.type.split("-")[1] === undefined ? (
                  <DropdownItem className='w-100' onClick={() => props.archiveConversation(props.item.id)}>
                    <span className='align-middle'>Arsipkan Percakapan</span>
                  </DropdownItem>
                ) : (
                  <DropdownItem className='w-100' onClick={() => props.unArchiveConversation(props.item.id)}>
                    <span className='align-middle'>Batal Arsipkan Percakapan</span>
                  </DropdownItem>
                )
              }
              {
                props.item.is_un_read ? (
                  <DropdownItem className='w-100' onClick={() => props.markAsRead(props.item.id)}>
                    <span className='align-middle'>Tandai Sudah Dibaca</span>
                  </DropdownItem>
                ) : (
                  <DropdownItem className='w-100' onClick={() => props.markAsUnRead(props.item.id)}>
                    <span className='align-middle'>Tandai Belum Dibaca</span>
                  </DropdownItem>
                )
              }

            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </div>
      </div>
    </>
  )
}